/* rem布局 */
const setHtmlFontSize = () => {
    const htmlDom = document.getElementsByTagName('html')[0];
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (htmlWidth >= 750) {
        htmlWidth = 750;
    }
    // let ScreenWidth = window.screen.width;
    // let B = ScreenWidth / 640;
    // htmlWidth = htmlWidth * B;
    htmlDom.style.fontSize = `${htmlWidth / 375}px`;
};
window.onresize = setHtmlFontSize;
setHtmlFontSize();



//////////////////
// WEBPACK FOOTER
// ./src/tool/rem.js
// module id = VN6t
// module chunks = 10